import React, { useCallback, useEffect, useRef } from 'react';
// import QrReader from "react-qr-scanner";
import { QrReader } from 'react-qr-reader';

import { decryptData } from '../../../utils/crypto';
import { CircularProgress } from '@mui/material';
import toast from 'react-hot-toast';
import { useState } from 'react';
const QrScanner = ({ onScan, setSnackbarData, isLoading, floor }) => {
  let qrData = null;
  let curTime = -1;
  let timeout = null;
  const [hasPermission, setHasPermission] = useState(false);
  const [isScanning, setIsScanning] = useState(true);
  const invalidQrCount = useRef(0);

  const getTimeDiff = (delay) => {
    const newTime = new Date().getTime();
    const diff = newTime - curTime;
    if (diff >= delay) {
      curTime = newTime;
      return true;
    } else {
      return false;
    }
  };

  const getDecryptedData = (data) => {
    let decryptedData = decryptData(data);
    return decryptedData;
  };
  const handleScan = (result) => {
    if (!isScanning || !result) return;
    
    console.log("Handle Scanned :-", floor);
    try {
      if (floor == 3) {
        if (getTimeDiff(2000)) {
          setIsScanning(false);
          onScan(result.text);
          setTimeout(() => setIsScanning(true), 3000);
        }
        return;
      }
      
      console.log('result', result);
      let decryptedData = getDecryptedData(result.text);
      if (getTimeDiff(2000)) {
        setIsScanning(false);
        onScan(decryptedData);
        setTimeout(() => setIsScanning(true), 3000);
      }
    } catch (e) {
      if (invalidQrCount.current < 2) {
        toast.error('Invalid QR Code', { id: 'invalid-qr-code' });
        invalidQrCount.current++;

        setTimeout(() => {
          invalidQrCount.current = 0;
        }, 1000);
      }
    }
  };
  // if (!isLoading) {
  //   if (data) {
  //     // debugger;
  //     setIsLoading(true);
  //     onScan(data.text);
  //   }
  // }

  const handleError = (err) => {
    console.error(err);
  };

  //   useEffect(() => {
  //     setResult(null);
  //     return () => {
  //       setResult(null);
  //     };
  //   }, []);

  // useEffect(() => {
  //   // Ask for camera access when page is loaded
  //   navigator.mediaDevices
  //     .getUserMedia({ video: true })
  //     .then((stream) => {
  //       setHasPermission(true);
  //       // Stop the stream immediately if not needed yet
  //       stream.getTracks().forEach((track) => track.stop());
  //     })
  //     .catch((err) => {
  //       console.error('Camera permission denied:', err);
  //       setHasPermission(false);
  //     });
  // }, []);

  useEffect(() => {
    window['ReactNativeWebView'] &&
      window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'giveCameraPermission', value: true }));
  }, []);

  return isLoading ? (
    <div
      className={'d-flex align-items-center justify-content-center'}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        height: '250px',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderRadius: '10px',
      }}
    >
      <CircularProgress size={50} thickness={4} />
    </div>
  ) : (
    // hasPermission && (
    <QrReader
      scanDelay={50}
      // onError={handleError}
      onResult={handleScan}
      constraints={{
        facingMode: 'environment',
        // sampleRate: {
        //   ideal: 10,
        // },
        // aspectRatio: { ideal: 1 },
      }}
      containerStyle={{
        height: 'inherit',
      }}
      videoContainerStyle={{
        padding: '0',
      }}
      videoStyle={{
        position: 'relative',
        height: 'inherit',
        width: 'inherit',
        border: '1px solid pink',
      }}
    />
    // )
  );
};

export default QrScanner;
